module.exports = __webpack_public_path__ + "img/participant-select-mobile-fr.34c6da25.jpg";